export default __webpack_public_path__ + "static/media/ico_user.f0994b6f.png";